import React, { useState, useEffect } from "react";
import { toast } from "react-hot-toast";
import {
  TextField,
  Button,
  Card,
  CardHeader,
  CardContent
} from "@material-ui/core";
import Loader from "../components/Loader";
import ProductService from "../services/ProductService";

const CartonSlips = ({ isLoggedIn, navigate }) => {
  const productService = new ProductService();
  const [formData, setFormData] = useState({
    SONumber: "",
    FromNo: "",
    ToNo: "",
    qty: ""
  });
  const [loading, setLoading] = useState(true);
  const [formErrors, setFormErrors] = useState({
    SONumber: "",
    FromNo: "",
    qty: "",
    ToNo: ""
  });
  const { SONumber, FromNo, ToNo, qty } = formData;

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
    if (name === "qty") {
      const newQty = value;
      const fromNo = parseInt(formData.FromNo);
      if (!isNaN(fromNo) && !isNaN(newQty)) {
        const newToNo = fromNo + parseInt(newQty) - 1;
        setFormData((prevFormData) => ({
          ...prevFormData,
          ToNo: newToNo.toString()
        }));
        formData.ToNo = newToNo.toString();
      }
    }
    validateForm(name, value);
  };

  const submitHandler = (event) => {
    event.preventDefault();
    let isfrmvalid = true;
    let checkerror = formErrors;

    Object.entries(checkerror).map(([key, value]) => {
      const val = formData[key];
      let valid = validateForm(key, val);
      if (!valid) {
        setFormErrors(checkerror);
        isfrmvalid = false;
      }
      return isfrmvalid;
    });
    if (isfrmvalid) {
      try {
        setLoading(true);
        const year = new Date().getFullYear();
        const csvData = [];
        for (let i = parseInt(FromNo); i <= parseInt(ToNo); i++) {
          const val = i.toString().padStart(7, "0");
          const ival = "GL" + i.toString().padStart(7, "0");
          csvData.push({ SRNo: ival, CartonId: `SID-GL-${year}-${val}` });
        }

        // Convert data to CSV format
        const header = Object.keys(csvData[0]).join(",");
        const rows = csvData.map((obj) => Object.values(obj).join(","));
        const csvContent = `${header}\n${rows.join("\n")}`;

        // Download CSV file
        const blob = new Blob([csvContent], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "carton_slip.csv";
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        const SaveCartonId = {
          soNumber: SONumber,
          fromNo: `SID-${year}-GL-${FromNo.toString().padStart(5, "0")}`,
          toNo: `SID-${year}-GL-${ToNo.toString().padStart(5, "0")}`
        };
        productService
          .SaveCartonIds(SaveCartonId)
          .then((response) => {
            //toast.success("Details Updated successfully");
            //console.log("Carton IDs saved successfully:", response.data);
          })
          .catch((error) => {
            console.error("Error while saving carton IDs:", error);
            toast.error("Failed to save carton IDs");
          });

        const type = "SID";
        const value = ToNo;
        productService
          .UpdateIds(type, value)
          .then((response) => {
            //toast.success("IDs updated successfully");
            //console.log("Response Data:", response.data);
          })
          .catch((error) => {
            console.error("API request failed:", error);
            toast.error("Failed to update IDs");
          });

        // Reset form fields and error messages
        setFormData({
          SONumber: "",
          FromNo: "",
          ToNo: "",
          qty: ""
        });
        GetFromNo();
        setLoading(false);
      } catch (error) {
        console.error("CartonSlips failed:", error);
        toast.error("CartonSlips failed");
      }
    }
  };

  const validateForm = (name, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
    const errors = formErrors;
    let IsValid = true;
    switch (name) {
      case "SONumber":
        if (value.length < 1) {
          IsValid = false;
          errors.SONumber = "Please enter SO Number.";
        } else errors.SONumber = "";
        break;
      case "FromNo":
        if (value.length < 1) {
          IsValid = false;
          errors.FromNo = "Please enter From No.";
        } else errors.FromNo = "";
        break;
      case "qty":
        if (value.length < 1) {
          IsValid = false;
          errors.qty = "Please enter issue qty.";
        } else {
          errors.qty = "";
        }
        break;
      default:
        break;
    }

    setFormErrors(errors);
    return IsValid;
  };

  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    if (storedToken) {
      isLoggedIn(true);
    } else {
      isLoggedIn(false);
      navigate("/login");
    }
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    GetFromNo();
  }, [isLoggedIn, navigate]);

  const GetFromNo = () => {
    productService
      .GetIds()
      .then((response) => {
        const data = response.responseMessage.split("VAL");
        setFormData((prevFormData) => ({
          ...prevFormData,
          FromNo: (parseInt(data[0], 10) + 1).toString()
        }));
      })
      .catch((error) => {
        console.error("API request failed:", error);
        toast.error("Failed to get From Number");
      });
  };

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div className="mt-3 py-14">
          <div className="container Mappingg">
            <Card>
              <CardHeader
                className="mappping"
                title={
                  <h1 className="text-center text-inverse">
                    Carton Slip Generator (SID)
                  </h1>
                }
              />
              <CardContent>
                <form className="container" id="needs-validation" noValidate>
                  <div className="row">
                    <div className="col-lg-6 col-sm-6 col-12">
                      <div className="form-group">
                        <label
                          className="block text-gray-700 text-sm font-bold mb-2"
                          htmlFor="SONumber"
                        >
                          SO Number
                        </label>
                        <TextField
                          className="w-full"
                          id="SONumber"
                          type="text"
                          name="SONumber"
                          value={SONumber}
                          onChange={handleChange}
                          placeholder="Enter SO Number"
                          error={!!formErrors.SONumber}
                          helperText={formErrors.SONumber}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-sm-6 col-12">
                      <div className="form-group">
                        <label
                          className="block text-gray-700 text-sm font-bold mb-2"
                          htmlFor="fromNo"
                        >
                          From No.
                        </label>
                        <TextField
                          className="w-full"
                          id="fromNo"
                          type="number"
                          name="FromNo"
                          value={FromNo}
                          onChange={handleChange}
                          disabled
                          placeholder="Enter From Number"
                          error={!!formErrors.FromNo}
                          helperText={formErrors.FromNo}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6 col-sm-6 col-12">
                      <div className="form-group">
                        <label
                          className="block text-gray-700 text-sm font-bold mb-2"
                          htmlFor="qty"
                        >
                          Quantity
                        </label>
                        <TextField
                          className="w-full"
                          id="qty"
                          type="number"
                          name="qty"
                          value={qty}
                          onChange={handleChange}
                          placeholder="Enter Quantity"
                          error={!!formErrors.qty}
                          helperText={formErrors.qty}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-sm-6 col-12">
                      <div className="form-group">
                        <label
                          className="block text-gray-700 text-sm font-bold mb-2"
                          htmlFor="ToNo"
                        >
                          To No.
                        </label>
                        <TextField
                          className="w-full"
                          id="ToNo"
                          type="number"
                          name="ToNo"
                          onChange={handleChange}
                          disabled
                          value={ToNo}
                          placeholder="Enter To Number"
                          error={!!formErrors.ToNo}
                          helperText={formErrors.ToNo}
                        />
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-lg-12 col-sm-12 col-12 text-center my-3">
                      <Button
                        onClick={submitHandler}
                        className="bg-blue-500 mt-3 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        type="button"
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </form>
              </CardContent>
            </Card>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartonSlips;
